<template>
    <TheHeader :key="filteredApprovalList"></TheHeader>

    <div class="container-fluid">
        <div class="container">
            <form name="form">
                <div class="contain row">
                    <ThePageLoading v-if="isPageLoading"></ThePageLoading>

                    <div class="page-container card col-md-8" v-if="!isPageLoading">
                        <ThePageHeader :renderSearch="true" :isSearching="isSearching" @search="filterByCompanyName"></ThePageHeader>
                        
                        <TabView class="p-1" v-if="!pageError" v-model:activeIndex="activeIndex">
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-fw pi-calendar"></i>
                                    <span>RPK</span> 
                                    <Badge class="ms-1 approval-badge" :value="approvalCount" severity="danger" v-if="approvalCount != null && approvalCount > 0"></Badge>
                                </template>
                                
                                <div class="row" v-if="filteredApprovalList != null && filteredApprovalList.length > 0">
									<div class="col-md-12" v-for="(approval, companyIndex) in filteredApprovalList" :key="companyIndex">
                                        
                                        <DataTable :value="approval.companyReports" sortField="companyName" :sortOrder="-1" tableStyle="min-width: 50rem">
                                            <Column field="company.name" header="Company Name" sortable style="min-width: 15rem">
                                                <template #body="slotProps">
                                                    <span>{{ slotProps.data.company.name + ' (' + slotProps.data.company.code + ')' }} </span>
                                                </template>
                                            </Column>
                                            <Column field="fileId" header="File ID" sortable style="min-width: 14rem"></Column>
                                            <Column field="submissionDate" header="Submitted on" :sortable="true" style="min-width: 12rem">
                                                <template #body="slotProps">
                                                    <span>{{ slotProps.data.submissionDate }}</span>
                                                </template>
                                            </Column>
                                            <Column field="identifier" :sortable="false" style="min-width: 12rem">
                                                <template #body="slotProps">
                                                    <div class="d-flex justify-content-end">
                                                        <Button class="p-button-sm p-button-warning me-4" @click="view(slotProps.data)" label="View"/>
                                                        <!-- <Button class="p-button-sm p-button-warning me-4" @click="checkUnsaved(slotProps.data, 1)" label="View"/>
                                                        <Button class="p-button-sm p-button-danger me-1" @click="reject(slotProps.data, 'RPK')" label="Reject"/>
                                                        <Button class="p-button-sm p-button-success" @click="approve(slotProps.data, 'RPK', companyIndex, itemIndex)" label="Accept"/> -->
                                                    </div>
                                                </template>
                                            </Column>
                                        </DataTable>
									</div>
                                </div>

                                <div class="row" v-else>
                                    <div class="col-md-12">
                                        <div class="error-no-record mt-3">
                                            <FontAwesomeIcon :icon="['fas', 'image']" size="2x"/>
                                            <h6><span>No Record Found</span></h6>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </TabView>

                        <TheSheetsDialog :isFromApproval="true" :identifier="sheetDialog.identifier" :name="sheetDialog.companyName" :type="'rpk'" :balanceSheetDate="sheetDialog.balanceSheetDate == null ? null : formatToDate(sheetDialog.balanceSheetDate)" :currencyCode="sheetDialog.currencyCode" :purpose="sheetDialog.purpose" :id="sheetDialog.id" :templateIndex="sheetDialog.templateIndex" :status="sheetDialog.status" :visible="sheetDialog.visible" :loading="sheetDialog.loading" :isUnsaved="sheetDialog.isUnsaved" :isConsolidated="sheetDialog.isConsolidated" :reportSheets="sheetDialog.companyReportSheets" @save="updateSheets" @autoSave="updateSheetCached" @deleteCached="deleteSheetCached" @cancel="closeSheetDialog"></TheSheetsDialog>

                        <ThePageError @back-event="back" :pageError="pageError" v-if="pageError != ''"></ThePageError>
                    </div>

                    <TheFooter></TheFooter>
                </div>
            </form>
        </div>
    </div>
    
    <Dialog v-model:visible="isShowUnsavedConfirmation" header="Recover Unsaved Changes" modal :style="{ width: '40vw' }">
		<p v-if="isViewer">
            Any data entered by you (as a viewer) will not be saved or processed
        </p>
        <p v-else>
			Unsaved changes detected and available to recovery. Would you like to recover these changes now?
		</p>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="sheets(1, false, null)" text />
			<Button label="Yes" icon="pi pi-check" @click="sheets(1, true, null)" :hidden="isViewer" />
		</template>
	</Dialog>

    <Dialog v-model:visible="dialog.visible" header="Confirmation" modal :style="{width: '40vw'}">
		<div>
			<div class="row">
				<div class="col-md-12 d-flex">
					<i class="mr-3 align-self-center" :class="dialog.icon != null && dialog.icon != '' ? dialog.icon : 'pi pi-exclamation-triangle'" style="font-size: 1.5rem;" />
					<span>{{ dialog.message }}</span>
				</div>

				<div class="col-md-12 mt-3" v-if="dialog.withRemarks">
					<Textarea v-model="dialog.remarks" :autoResize="true" rows="5" cols="30" maxlength="255" placeholder="Remarks" autofocus />
				</div>

			</div>
		</div>

		<template #footer>
			<div class="d-flex justify-content-end">
				<TheLoading v-if="this.dialog.loading"></TheLoading>

				<Button class="p-button-text p-button-sm" label="No" icon="pi pi-times" @click="closeDialog" />
				<Button class="p-button-sm" label="Yes" icon="pi pi-check" @click="onConfirm" :disabled="(dialog.status == 'Rejected' && dialog.remarks == '')"/>
			</div>
		</template>
	</Dialog>

    <Dialog v-model:visible="isShowGlobalFilterConfirmation" header="Global Filter in use" modal :style="{ width: '40vw' }">
        <p>
			Click “No” to clear the Global Filter and view all companies.<br>
            Click “Yes” to proceed with Global Filter.
		</p>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="proceedWithResetGlobalFilter" text />
			<Button label="Yes" icon="pi pi-check" @click="proceedGlobalFilterWarning" />
		</template>
	</Dialog>
</template>

<script lang="ts">
    import {defineComponent} from "vue";
    import store from "@/store";
    import approvalApi from "@/api/approval-api";
    import companyReportApi from "@/api/companyreport-api";
	import companyReportSheetApi from "@/api/companyreportsheet-api";
    import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";
    import consoGroupApi from "@/api/consogroup-api";

    import applicationStatusMixin from "@/mixin/application-status";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import formulaMixin from "@/mixin/formula";
    import excelUtils from "@/mixin/utils/excel-utils";
	
    import TheLoading from "@/components/TheLoading.vue";
    import TheHeader from "@/components/TheHeader.vue";
    import TheFooter from "@/components/TheFooter.vue";
    import ThePageHeader from "@/components/ThePageHeader.vue";
    import ThePageLoading from "@/components/ThePageLoading.vue";
    import ThePageError from "@/components/ThePageError.vue";
    import TheConfirmationDialog from "@/components/TheConfirmationDialog.vue";
	import TheSheetsDialog from "@/components/TheSheetsDialog.vue";
    import companyreportApi from "@/api/companyreport-api";
	
    export default defineComponent({
        mixins: [applicationStatusMixin, dateUtilsMixin, formulaMixin, excelUtils],
        components: {
            TheLoading,
            TheHeader,
            TheFooter,
            ThePageHeader,
            ThePageLoading,
            ThePageError,
            TheSheetsDialog,
        },
        data() {
            return {
                pageError: (store.getters.error == undefined ? '' : store.getters.error),
                approvalCount: '',
                isPageLoading: false,
                isLoading: false,
                displayModal: false,
                activeIndex: 0,
                approvalList: [{company: null as any, companyReports: [] as any[], isCollapsed: false}],
                filteredApprovalList: [{company: null as any, companyReports: [] as any[], isCollapsed: false}],
                dialog: {identifier: null, visible: false, loading: false, message: "", type: '', icon: '', remarks: '', withRemarks: true, isOptionalRemarks: false, consoGroup: null as any, status: '', index: {companyIndex: 0, itemIndex: 0}}, 
                sheetDialog: {identifier: null, companyName: null as any, balanceSheetDate: null as any, currencyCode: null as any, purpose: null as any, id: 0.0, templateIndex: 0, status: '', visible: false, loading: false, isUnsaved: false, index: {companyIndex: 0, itemIndex: 0}, isConsolidated: false, companyReportSheets: null as any},
                companyReport: null as any,
                companyReportSheet: {identifier: null, sheet: {identifier: null}, content: {template: null}},
                companyReportSheets: [] as any[],
                sheetType: null as any,
                templateIndex: null as any,
                isShowUnsavedConfirmation: false,
				isShowGlobalFilterConfirmation: false,
				isPassGlobalFilter: false,
                selectedRPK: null as any,
                isSearching: false,
                isExporting: false,
                unsavedId: 0.0,
            }
        },
        watch: {
            filterLegalGroup(newValue: any) {
                this.load();
            }
        },
        computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			},
			filterLegalGroupId() {
				return store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null;
			},
        },
        mounted() {
            if (this.pageError == '') {
                this.load();
            }
        },
        methods: {
            load() {
                this.isPageLoading = true;

                let r1 = approvalApi.approvalCompanyReportList({filterLegalGroupModel: {value: this.filterLegalGroup}}, 'rpk');
                let r2 = approvalApi.approvalTotalCount({filterLegalGroupModel: {value: this.filterLegalGroup}});

                Promise.all([r1, r2])
                    .then((values: any) => {
                        if (values != null) {
                            for (var i = 0; i < values.length; i++) {
                                if (values[i] != null) {
                                    if (values[i].success) {
                                        if (values[i].data != null) {
                                            if (i == 0) {
                                                this.isPageLoading = false;
												values[i].data.forEach((approval:any) => {
													approval.isCollapsed = false;

                                                    approval.companyReports.forEach((report: any) => {
                                                        report.companyReportSheets = []
                                                    });
												})

                                                this.approvalList = values[i].data
                                                this.filteredApprovalList = JSON.parse(JSON.stringify(this.approvalList));
                                                const rpkId = this.$store.getters.getSelectedRpkId;
                                                if (rpkId != null) {
                                                    this.approvalList.forEach((companyReport: any) => {
                                                        if (companyReport.identifier == rpkId) {
                                                            this.selectedRPK = companyReport;
                                                        }
                                                    });
                                                    this.$store.dispatch('clearSelectedRpkId');
                                                    this.checkUnsaved(this.selectedRPK, 1);
                                                }
                                            }
                                            
                                            else if (i == 1) {
                                                this.approvalCount = '';
                                                if (values[i].data.count != null) {
                                                    this.approvalCount = values[i].data.count.toString();
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        this.pageError = error;
                        this.isPageLoading = false;
                    });
            },
            toggleCollapse(type: any, companyIndex: any, itemIndex: any) {
                if (type == "RPK") {
					if (this.approvalList[companyIndex].isCollapsed == null) {
						this.approvalList[companyIndex].isCollapsed = true;
					}
					this.approvalList[companyIndex].isCollapsed = !this.approvalList[companyIndex].isCollapsed;

                }
            },
            back() {
                this.$router.push("/home");
            },
            checkUnsaved(selectedRPK: any, templateIndex: any) {
                this.selectedRPK = selectedRPK;
				if (this.filterLegalGroupId != null && this.isPassGlobalFilter == false) {
					this.isShowGlobalFilterConfirmation = true;
					return;
				}
                this.isPassGlobalFilter = false;
                companyReportApi.companyReportCheckUnsaved(selectedRPK.identifier, 'rpk', templateIndex)
					.then(response => {
							this.unsavedId = response.data.unsavedId;
							this.sheetDialog.templateIndex = templateIndex;
							response.data.hasUnsaved ? this.isShowUnsavedConfirmation = true : this.sheets(templateIndex, false, null);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
            sheets(templateIndex: any, getUnsaved: any, companyReportSheets: any) {
				getUnsaved ? this.sheetDialog.isUnsaved = true :this.sheetDialog.isUnsaved = false;
				this.isShowUnsavedConfirmation = false;
				
                this.sheetDialog.identifier = this.selectedRPK.identifier;
                this.sheetDialog.companyName = this.selectedRPK.company.name;
                this.sheetDialog.balanceSheetDate = this.selectedRPK.balanceSheetDate;
                this.sheetDialog.currencyCode = this.selectedRPK.currency.code;
                this.sheetDialog.purpose = this.selectedRPK.purpose.name;
                this.sheetDialog.isConsolidated = this.selectedRPK.isConsolidated;
                this.sheetDialog.templateIndex = templateIndex;
                this.sheetDialog.isUnsaved ? this.sheetDialog.id = this.unsavedId : this.sheetDialog.id = this.selectedRPK.id;
				this.sheetDialog.status = this.selectedRPK.status;
				this.sheetDialog.companyReportSheets = companyReportSheets;
                this.sheetDialog.visible = true;

                document.body.classList.add("dialog-open");
            },
            updateSheets(companyReportSheets: any, isCloseSheetDialog: any) {
                this.sheetDialog.loading = true;

                let rs = [] as any[];

                companyReportSheets.forEach((companyReportSheet: any, index: any) => {
                    if (companyReportSheet.sheetError == '') {
                        this.companyReportSheet.identifier = companyReportSheet.identifier;
                        this.companyReportSheet.sheet = companyReportSheet.sheet;
                        this.companyReportSheet.content.template = companyReportSheet.template;
                        let r = companyReportSheetApi.companyReportSheetUpdate({identifier: this.sheetDialog.identifier, companyReportSheet: this.companyReportSheet}, this.sheetDialog.templateIndex)
                            .catch(error => {
                                this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                            })
                        rs.push(r);
                    }
                });

                let r1 = companyReportApi.companyReportUpdateId({companyReport: this.selectedRPK}, 'rpk', this.sheetDialog.templateIndex);
                rs.push(r1);

                Promise.all(rs)
                    .then((values: any) => {
                        if (values != null) {
                            this.sheetDialog.id = this.selectedRPK.id;
                        }
                        this.sheetDialog.loading = false;
                        
						if (isCloseSheetDialog) {
							this.closeSheetDialog(true, null, null, null, null);
						}
                    })
                    .catch(error => {
                        this.sheetDialog.loading = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    })
            },
            updateSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				var companyReportSheetCached = {identifier: null, sheet: {identifier: null}, content: {template: null}, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.sheet = companyReportSheet.sheet;
				companyReportSheetCached.content.template = companyReportSheet.template;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;
				
				companyReportSheetApi.companyReportSheetUpdateCached({identifier: this.sheetDialog.identifier, companyReportSheet: companyReportSheetCached}, this.sheetDialog.templateIndex)
					.then(response => {
						//
					})
					.catch(error => {
						//
					})
			},
			deleteSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any, isCloseSheetDialog: any) {
				this.dialog.loading = true;
				
				var companyReportSheetCached = {identifier: null, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;
				
				companyReportSheetApi.companyReportSheetDeleteCached({identifier: this.sheetDialog.identifier, companyReportSheet: companyReportSheetCached}, this.sheetDialog.templateIndex)
					.then(response => {
						this.dialog.loading = false;
						
						if (isCloseSheetDialog) {
							this.closeSheetDialog(true, companyReportSheetCached.pageIndex, companyReportSheetCached.scrollDetail.scrollTop, companyReportSheetCached.scrollDetail.scrollLeft, companyReportSheetCached.lastAccessedCell);
						}
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
            view(selectedRPK: any) {
                this.$router.push({ path: "/companyreport/rpk/view/" + selectedRPK.identifier, state: { from: this.$router.currentRoute.value.fullPath }	});
            },
            approve(selectedRPK: any, type: string, companyIndex: any, itemIndex: any) {
                this.selectedRPK = selectedRPK;
                this.dialog.identifier = selectedRPK.identifier;
                this.dialog.type = type;
                this.dialog.remarks = '';
                this.dialog.message = "Are you sure you want to accept this application?";
                this.dialog.icon = "pi pi-check";
                this.dialog.withRemarks = true;
                this.dialog.isOptionalRemarks = true;
                this.dialog.status = "Accepted";
                this.dialog.visible = true;
                this.dialog.index = {companyIndex: companyIndex, itemIndex: itemIndex};
            },
            reject(selectedRPK: any, type: string) {
                this.selectedRPK = selectedRPK;
                this.dialog.identifier = selectedRPK.identifier;
                this.dialog.type = type;
                this.dialog.remarks = '';
                this.dialog.message = "Are you sure you want to reject this application?";
                this.dialog.icon = "pi pi-times";
                this.dialog.withRemarks = true;
                this.dialog.isOptionalRemarks = false;
                this.dialog.status = "Rejected";
                this.dialog.visible = true;
            },
            onConfirm(statusMessage: any) {
                this.dialog.loading = true;
                let result = [] as any[];
                var sheetType = this.selectedRPK.sheetType;

                approvalApi.approvalCompanyReportUpdateStatus(this.dialog.identifier, this.dialog)
                    .then((response: any) => {
                        companyReportSheetTemplateApi.companyReportSheetTemplateViewComments(sheetType, this.dialog.identifier, 1, {})
                            .then(response => {
                                if (response) {
                                    this.companyReportSheets = response.data.companyReportSheets;
                                }
                                this.companyReportSheets.forEach((companyReportSheet: any) => {
                                    if (companyReportSheet.sheetComments.length > 0) {
                                        result.push([companyReportSheet.title.sheet + " ID:" + companyReportSheet.title.id]);
                                        result.push(['', 'Comments', 'Last Modified By', 'Time'])
                                        companyReportSheet.sheetComments.forEach((sheetComment: any) => {
                                            result.push([
                                                sheetComment.cell,
                                                this.getCommentValue(sheetComment.comment),
                                                this.getCommentUsername(sheetComment.comment),
                                                this.getCommentTime(sheetComment.comment)
                                            ]);
                                        });
                                        result.push([]);
                                        result.push([]);
                                        result.push([]);
                                    }
                                });
                                let filename = "_" + this.selectedRPK.fileId + "_comments" + ".xlsx";
                
                                if (result.length > 0){
                                    this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
                                    this.downloadExcelFileWithArray(result, filename);
                                }
                                    
                                this.dialog.loading = false;
                                this.dialog.visible = false;
                                this.load();
                            })
                            .catch(error => {
                                this.$toast.add({ severity: "error", summary: "Error", detail: error, life: 6000});
                            });
                    })
                    .catch((error) => {
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                        this.dialog.loading = false;
                    })
            },
            closeDialog() {
                this.dialog.visible = false;
            },
            getCommentValue(comment: any) {
                if (comment == null) {
                    return '';
                }
                if (typeof comment === 'string') {
                    return comment;
                }
                return comment.value ?? '';
            },
            getCommentUsername(comment: any) {
                if (comment == null || typeof comment === 'string') {
                    return '';
                }
                return comment.lastModifiedBy ?? '';
            },
            getCommentTime(comment: any) {
                if (comment == null || typeof comment === 'string') {
                    return '';
                }
                return comment.time ?? '';
            },
            closeSheetDialog(hasCached: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				if (!hasCached) {
					var lastAccessedDetail = {pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
					lastAccessedDetail.pageIndex = pageIndex;
					lastAccessedDetail.scrollDetail.scrollTop = scrollTop;
					lastAccessedDetail.scrollDetail.scrollLeft = scrollLeft;
					lastAccessedDetail.lastAccessedCell = lastAccessedCell;
					
					companyReportApi.companyReportLastAccess({identifier: this.sheetDialog.identifier, lastAccessedDetail: lastAccessedDetail}, 'rpk', this.sheetDialog.templateIndex)
						.then(response => {
							//
						})
						.catch(error => {
							//
						})
				}
				this.sheetDialog.visible = false;
				document.body.classList.remove("dialog-open");
                this.load();
			},
            filterByCompanyName(value: any) {
				this.isSearching = true;
				value = value.trim().toLowerCase();
                if (value == '') {
                    this.filteredApprovalList = JSON.parse(JSON.stringify(this.approvalList));
                } else {
                    this.filteredApprovalList[0].companyReports = this.approvalList[0].companyReports.filter(companyReport=> {
                        return (companyReport.company.name.toLowerCase().indexOf(value) != -1 || companyReport.fileId.toLowerCase().indexOf(value) != -1)
                    });
                }
				this.isSearching = false;
            },
            proceedWithResetGlobalFilter() {
                this.isShowGlobalFilterConfirmation = false;
                this.isPassGlobalFilter = true; 
                this.$store.dispatch('updateSelectedRpkId', this.selectedRPK.identifier);
				this.$store.dispatch('filterLegalGroupModelSession', null);
            },
            proceedGlobalFilterWarning() {
                this.isPassGlobalFilter = true; 
                this.isShowGlobalFilterConfirmation = false; 
                this.checkUnsaved(this.selectedRPK, 1);                
            }
        }
    });
</script>
